import withStore, { TLoadingAwarePresenter, TPresentable } from "../withStore";
import { IReportingPeriodItem } from "../../model/report/ReportingPeriodItem";
import Application from "../../Application";
import { IApplicantReport } from "../../model/report/ApplicantReport";
import GetDataReport4Interactor from "../../interactor/report/GetDataReport4Interactor";
import { IBusinessRule } from "../../model/evaluation/BusinessRule";
import GetRiskCriteriaInteractor from "../../interactor/report/GetRiskCriteriaInteractor";

export interface TReport4Presenter extends TLoadingAwarePresenter {
  report4ReportingPeriodList: IReportingPeriodItem[];
  report4CurrentReportingPeriod?: IReportingPeriodItem;
  report4?: IApplicantReport[];
  report4RiskCriteria: IRiskCriteriaPresentationModel[];
  report4SelectedRiskCriteriaIds: number[];
}

export interface IReport4Presenter extends TReport4Presenter, TPresentable {
  loadReportingPeriodList(reportingPeriodList: IReportingPeriodItem[]): void;
  onChangeReportingPeriod(reportingPeriodId: number): void;
  getPDFReport4(selectedCriteriaIds: number[]): Promise<any>;
  onRiskCriteriaChange(selectedRiskCriteriaIds: any[]): void;
}
export interface IRiskCriteriaPresentationModel extends IBusinessRule {
  value: number;
  label: string;
}
const RiskCriteriaPresentationModelMapper = (
  riskCriteria: IBusinessRule[]
): IRiskCriteriaPresentationModel[] => {
  return (
    riskCriteria &&
    riskCriteria.map(riskCriterium => {
      return {
        ...riskCriterium,
        value: riskCriterium.id,
        label: riskCriterium.name
      };
    })
  );
};

const defaultState: TReport4Presenter = {
  report4ReportingPeriodList: [],
  report4SelectedRiskCriteriaIds: [],
  report4RiskCriteria: []
};

const Report4Presenter = withStore<IReport4Presenter, TReport4Presenter>(
  ({ application, store, loader, translate }): IReport4Presenter => {
    const _store = store;
    const _application: Application = application;
    const state = _store.getState<TReport4Presenter>();

    const loadReportingPeriodList = (
      report4ReportingPeriodList: IReportingPeriodItem[]
    ) => {
      _store.update({
        report4ReportingPeriodList
      });
    };

    const onChangeReportingPeriod = async (reportingPeriodId: number) => {
      const report4ReportingPeriodList = _store.getState<TReport4Presenter>()
        .report4ReportingPeriodList;
      const report4CurrentReportingPeriod = report4ReportingPeriodList.find(
        reportingPeriod => reportingPeriod.id === reportingPeriodId
      );
      let riskCriteria;
      if (report4CurrentReportingPeriod) {
        riskCriteria = await application.container
          .resolve<GetRiskCriteriaInteractor>("getRiskCriteria")
          .execute(report4CurrentReportingPeriod.id);
      }
      _store.update({
        report4CurrentReportingPeriod,
        report4RiskCriteria: RiskCriteriaPresentationModelMapper(riskCriteria),
        report4: undefined
      });
    };

    const getPDFReport4 = async () => {
      const report4CurrentReportingPeriod = _store.getState<TReport4Presenter>()
        .report4CurrentReportingPeriod;
      const report4SelectedRiskCriteriaIds = _store.getState<
        TReport4Presenter
      >().report4SelectedRiskCriteriaIds;
      loader.start("report4Loader");
      const report4 =
        report4CurrentReportingPeriod &&
        (await application.container
          .resolve<GetDataReport4Interactor>("getDataReport4")
          .execute(
            report4CurrentReportingPeriod.id,
            report4SelectedRiskCriteriaIds
          ));
      _store.update({
        report4,
        report4SelectedRiskCriteriaIds
      });
      loader.stop("report4Loader");
    };

    const onRiskCriteriaChange = (report4SelectedRiskCriteriaIds: string[]) => {
      _store.update({ report4SelectedRiskCriteriaIds, report4: undefined });
    };
    return {
      ...state,
      store: _store,
      loader,
      application: _application,
      translate,
      loadReportingPeriodList,
      onChangeReportingPeriod,
      getPDFReport4,
      onRiskCriteriaChange
    };
  },
  defaultState
);

export default Report4Presenter;
